<template>
  <div>
    <div class="w-100" :class="wrapperClass">
      <Selector
        v-if="loaded"
        :key="'category-selector'"
        :title="title"
        :multiple="true"
        :emit-path="false"
        :target-options="options"
        :max="max"
        :useTree="useTree"
        :selected-value="value"
        :tree-ref="tree"
        ref="selector"
        @change="setValue">

        <div v-if="isMobile && useTree" class="c-tree">
          <div class="c-tree__item">
            <tree
              :data="options"
              ref="tree"
              @check-change="change"
              node-key="value"
              :default-checked-keys="value"
              :check-strictly="true"
              show-checkbox
              accordion
            ></tree>
          </div>

          <div class="d-flex justify-content-between align-items-center border-top c-bar__action">
            <div class="me-5"
              :class="value.length === max ? 'text-danger' : ''">
              已選擇 {{ value.length }} / {{ max }}
            </div>
            <div class="d-flex align-items-center">
              <a href="javascript://"
                class="text-primary fw-medium me-3"
                @click="clearSelector()"
              >
                清除
              </a>
              <a href="javascript://"
                class="btn btn-primary c-bar__action-btn"
                @click="closeModal"
              >
                確定
              </a>
            </div>
          </div>
        </div>

      </Selector>
    </div>
  </div>
</template>

<script>
const { reactive, onMounted, watch, toRefs, ref } = Vue;
import Selector from './Selector';
import Tree from 'element-ui/lib/tree';
import mobileCheck from '../../../services/utilities';

export default {
  name: 'CategorySelector',
  components: {
    Selector,
    Tree,
  },
  props: {
    type: String,
    path: String,
    max: Number,
    selectedValue: Array,
    selectorTitle: String,
    ageSelected: Array
  },
  setup(props, event) {
    const tree = ref(null);
    const selector = ref(null);

    const state = reactive({
      title: '',
      options: [],
      value: props.selectedValue,
      loaded: false,
      // max: 0,
      wrapperClass: '',
      isMobile: null,
      useTree: false,
      modalOpen: false
    });

    mobileCheck(state);

    onMounted(async () => {
      await configure();
    });

    watch(() => props.type, async (newVal, oldVal) => {
      if (newVal !== oldVal) {
        await configure();
      }
    });

    watch(() => state.isMobile, async (newVal) => {
      if (newVal) {
        await configure();

        // await checkMaxChecked(state.options);
      }
    });

    async function configure() {
      await getCategoryOptions();

      setWrapperClass();
      getCategoryTitle();
      canUseTree();
    };

    watch(() => props.ageSelected, () => {
      if (props.ageSelected !== null) {
        state.value = [];

        selector.value = null;

        getCategoryOptions();
      }
    });

    async function getCategoryOptions() {
      state.loaded = false;

      const params = {
        type: props.type,
        path: props.path,
      };

      if (props.ageSelected !== null) {
        params.ageSelected = props.ageSelected;
      }

      u.$http.post(
        u.route('category_ajax_options'),
        params
      ).then((res) => {
        state.options = res.data.data.data;

        Object.freeze(state.options);

        state.loaded = true;
      });
    }
    
    let labels = [];

    const change = async (e) => {
      clearOptionDisabled(state.options);

      tree.value.$data.root.childNodes.map((e) => {
        clearOptionIndeterminate(e);
      });

      tree.value.getCheckedNodes().map((v) => {
        let node = tree.value.getNode(v);

        if (node.level > 1) {
          disabledParent(node.parent);
        }

        if (!node.isLeaf) {
          disabledChildren(node);
        }
      });

      labels = [];

      loadCheckedLabelsFromTreeNode(tree.value.getCheckedNodes());

      setValue(tree.value.getCheckedKeys());

      selector.value.setTreeSelectedLabel(labels);

      await checkMaxChecked(state.options);
    };

    function loadCheckedLabelsFromTreeNode(nodes) {
      nodes.forEach((v) => {
        let label = '';
        let node = tree.value.getNode(v);

        do {
          if (node.label) {
            label = node.label + label;
          }

          node = node.parent;
        } while (node);

        labels.push(label);
      });
    }

    const clearOptionDisabled = (options) => {
      options.map((e, i) => {
        e.disabled = false;

        if (e.hasOwnProperty('children')) {
          clearOptionDisabled(e.children);
        }
      });
    };

    const clearOptionIndeterminate = (node) => {
      node.indeterminate = false;

      if (node.childNodes.length) {
        node.childNodes.map((e) => {
          clearOptionIndeterminate(e);
        });
      }
    };

    const disabledParent = (node) => {
      if (node.id) {
        node.data.disabled = true;
        node.indeterminate = true;

        disabledParent(node.parent);
      }
    };

    const disabledChildren = (node) => {
      node.childNodes.forEach((e) => {
        e.data.disabled = true;
        e.indeterminate = true;

        if (e.childNodes.length) {
          disabledChildren(e);
        }
      });
    };

    const checkMaxChecked = (node) => {
      if (state.value.length >= props.max) {
        let selectedArray = [];

        if (tree.value.defaultCheckedKeys) {
          selectedArray = tree.value.defaultCheckedKeys;
        } else {
          tree.value.getCheckedNodes().map((e) => {
            selectedArray.push(e.value);
          });
        }

        node.map(async (e) => {
          e.disabled = selectedArray.indexOf(e.value) === -1;

          if (e.hasOwnProperty('children')) {
            await checkMaxChecked(e.children);
          }
        });
      }
    };

    const clearSelector = () => {
      tree.value.setCheckedKeys([]);
    };

    const setValue = (v) => {
      state.value = v;
      event.emit('change', v);
    };

    const setWrapperClass = () => {
      props.type === 'lesson' || props.type === 'college'
        ? state.wrapperClass = 'c-category-selector'
        : state.wrapperClass = 'position-relative';
    };

    // const setMax = () => {
    //   props.type === 'article'
    //     ? state.max = 1
    //     : state.max = 3;
    // };

    const getCategoryTitle = () => {
      state.title = u.trans('edu.search.type.' + props.type) + '分類';

      if (props.selectorTitle) {
        state.title = props.selectorTitle;
      }
    };

    const canUseTree = () => {
      props.type === 'lesson' || props.type === 'college'
        ? state.useTree = true
        : state.useTree = false;
    };

    const closeModal = () => {
      selector.value.open = false;
    };

    return {
      ...toRefs(state),
      tree,
      selector,

      // Function
      setValue,
      change,
      clearSelector,
      closeModal,
    };
  }
};
</script>

<style scoped>

</style>
